import { Contact } from '@/models/contact.model';
import { cloneDeep } from 'lodash';
import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';

interface LoadingState {
  updatedRelativesForm: { [key: string]: boolean };
  updatedRelativesEntities: Contact[];
}

export const defaultUpdatedRelativesState: LoadingState = {
  updatedRelativesForm: {},
  updatedRelativesEntities: []
};

const state: LoadingState = cloneDeep(defaultUpdatedRelativesState);

const mutations: MutationTree<LoadingState> = {
  UPDATE_RELATIVES_FORM(returnedState: LoadingState, payload: { isSelected: boolean; id: string }): void {
    returnedState.updatedRelativesForm = {
      ...returnedState.updatedRelativesForm,
      [payload.id]: payload.isSelected
    };
  },
  ADD_RELATIVES_ENTITY(returnedState: LoadingState, payload: Contact): void {
    returnedState.updatedRelativesEntities.push(payload);
  },
  REMOVE_RELATIVES_ENTITY(returnedState: LoadingState, payload: string): void {
    returnedState.updatedRelativesEntities = returnedState.updatedRelativesEntities.filter(
      (item: Contact): boolean => item.id !== payload
    );
  },
  REMOVE_ITEM(returnedState: LoadingState, payload: string): void {
    delete returnedState.updatedRelativesForm[payload];
  },
  EMPTY_ALL_RELATIVES_DATA(returnedState: LoadingState, payload: string): void {
    returnedState.updatedRelativesEntities = [];
    returnedState.updatedRelativesForm = {};
  }
};

const actions: ActionTree<LoadingState, {}> = {
  updateRelativesForm: (
    { commit }: ActionContext<LoadingState, {}>,
    payload: { isSelected: boolean; id: string }
  ): void => {
    commit('UPDATE_RELATIVES_FORM', payload);
  },
  removeItem: ({ commit }: ActionContext<LoadingState, {}>, payload: string): void => {
    commit('REMOVE_ITEM', payload);
    commit('REMOVE_RELATIVES_ENTITY', payload);
  },
  addRelativesEntity: ({ commit }: ActionContext<LoadingState, {}>, payload: Contact): void => {
    commit('ADD_RELATIVES_ENTITY', payload);
  },
  emptyAllRelativesData: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('EMPTY_ALL_RELATIVES_DATA');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  updatedRelativesForm: (returnedState: LoadingState): { [key: string]: boolean } => {
    return returnedState.updatedRelativesForm;
  },
  updatedRelativesEntities: (returnedState: LoadingState): Contact[] => {
    return returnedState.updatedRelativesEntities;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
